import React from 'react';

function VerifyEmail() {
    return (
        <div className="verify-email-container">
            <h1>Verify Your Email</h1>
            <p>Please check your email and follow the instructions to verify your account.</p>
        </div>
    );
}

export default VerifyEmail;
